import { useState, useEffect, useCallback, useRef } from 'react';
import { useMicVAD } from './useCustomMicVad';
// import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition';
 
const useUserVoice = (onStart = () => { }, onStop = () => { }) => {
    // const {
    //     transcript,
    //     listening,
    //     resetTranscript,
    //     browserSupportsSpeechRecognition,
    // } = useSpeechRecognition();
 
    const [error, setError] = useState(null);
    const mediaStreamRef = useRef(null);
 
    const handleSpeechStart = useCallback(() => {
        try {
            onStart();
        } catch (e) {
            console.error('onStart callback error:', e);
            setError(e);
        }
    }, [onStart]);
 
    const handleSpeechEnd = useCallback(() => {
        try {
            onStop();
        } catch (e) {
            console.error('onStop callback error:', e);
            setError(e);
        }
    }, [onStop]);
 
    const vad = useMicVAD({
        onSpeechStart: handleSpeechStart,
        onSpeechEnd: handleSpeechEnd,
    });
 
    // useEffect(() => {
    //     if (!browserSupportsSpeechRecognition) {
    //         setError(new Error("Browser doesn't support Speech Recognition"));
    //         return;
    //     }
    //     resetTranscript()
    //     let isMounted = true;
 
    //     const initMicAndRecognition = async () => {
    //         try {
    //             const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    //             if (!isMounted) {
    //                 stream.getTracks().forEach((track) => track.stop());
    //                 return;
    //             }
    //             mediaStreamRef.current = stream;
    //             await SpeechRecognition.startListening({
    //                 continuous: true,
    //                 language: 'en-IN',
    //             });
    //         } catch (e) {
    //             console.error('Failed to get microphone or start listening:', e);
    //             setError(e);
    //         }
    //     };
 
    //     initMicAndRecognition();
 
    //     return () => {
    //         isMounted = false;
    //         resetTranscript()
    //         if (SpeechRecognition) {
    //             try {
    //                 SpeechRecognition.stopListening();
    //             } catch (e) {
    //                 console.warn('Error stopping listening during cleanup:', e);
    //             }
    //         }
    //         if (mediaStreamRef.current) {
    //             mediaStreamRef.current.getTracks().forEach((track) => track.stop());
    //             mediaStreamRef.current = null;
    //         }
    //     };
    // }, [browserSupportsSpeechRecognition]);
 
    // const start = useCallback(async () => {
    //     try {
    //         if (!browserSupportsSpeechRecognition) {
    //             throw new Error("Can't start: browser doesn't support Speech Recognition");
    //         }
    //         await SpeechRecognition.startListening({
    //             continuous: true,
    //             language: 'en-IN',
    //         });
    //     } catch (e) {
    //         console.error('Error starting speech recognition:', e);
    //         setError(e);
    //     }
    // }, [browserSupportsSpeechRecognition]);
 
    // const stop = useCallback(() => {
    //     try {
    //         SpeechRecognition.stopListening();
    //         SpeechRecognition.abortListening();
    //         console.log('stp before')
    //         vad.pause()
    //         console.log('stp after')
    //         if (mediaStreamRef.current) {
    //             mediaStreamRef.current.getTracks().forEach((track) => track.stop());
    //             mediaStreamRef.current = null;
    //         }
           
    //     } catch (e) {
    //         console.error('Error stopping speech recognition:', e);
    //         setError(e);
    //     }
    // }, []);
 
    return {
        transcript:vad.transcript,
        listening:vad.listening,
        resetTranscript:vad.resetTranscript,
        userSpeaking: vad.userSpeaking,
        error,
        start:vad.reStart,
        stop:vad.pause,
    };
};
 
export default useUserVoice;